import { render, staticRenderFns } from "./BaseYearFolder.vue?vue&type=template&id=2c6b44e4&scoped=true&"
import script from "./BaseYearFolder.vue?vue&type=script&lang=js&"
export * from "./BaseYearFolder.vue?vue&type=script&lang=js&"
import style0 from "./BaseYearFolder.vue?vue&type=style&index=0&id=2c6b44e4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6b44e4",
  null
  
)

export default component.exports